
import { defineComponent, reactive } from 'vue'

import NewslettersSignupStepLayout from '~/components/NewslettersSignup/NewslettersSignupStepLayout.vue'
import AlFormGroup from '~/components/ui/AlFormGroup/AlFormGroup.vue'
import AlTextInput from '~/components/ui/AlTextInput/AlTextInput.vue'
import AlButton from '~/components/ui/AlButton/AlButton.vue'
import { $api } from '~/plugins/axios'
import { useLoading } from '~/composables/loading.composable'

export default defineComponent({
  name: 'NewslettersSignupPersonalInformation',
  components: {
    AlFormGroup,
    NewslettersSignupStepLayout,
    AlTextInput,
    AlButton,
  },
  props: {
    subscriptionId: {
      type: String,
      required: true,
    },
  },
  emits: ['submit', 'failure'],
  setup () {
    const {
      isLoading,
      isError,
      setLoading,
      setError,
    } = useLoading()

    const form = reactive({
      firstName: '',
      lastName: '',
    })

    return {
      isLoading,
      isError,
      form,
      setLoading,
      setError,
    }
  },
  computed: {
    title () {
      return `<small>${this.$t('newslettersSignup.step2.title')}</small>`
    },
    subtitle () {
      return this.$t('newslettersSignup.step2.subtitle')
    },
  },

  methods: {
    async onSubmit () {
      const locale = this.$i18n.locale as string

      if (!await this.$validator.validate()) {
        return
      }

      this.setLoading(true)

      try {
        await $api.LemurService.updateSubscription(
          this.subscriptionId,
          locale,
          this.form,
        )
        this.$emit('submit')
      } catch (e) {
        this.$sentry.captureException(e)
        this.$emit('failure', e)
        this.isError = true
      } finally {
        this.setLoading(false)
      }
    },
  },
})
